module.exports = __webpack_public_path__ + "static/img/icon_94_gonglueno.124ae937.png";